<template>
  <div class="gameplay-round">
    <p class="text3">Round {{ round + 1 }}</p>
    <div class="horizontal center">
      <img class="clock" src="@/assets/clock.svg" alt />
      <p class="point-value">{{ pointValue }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    round: Number,
    pointValue: Number
  }
};
</script>

<style lang="scss" scoped>
.gameplay-round {
  user-select: none;
  flex: 1;
}
.clock {
  width: rems(40px);
  height: rems(40px);
  margin-right: rems(12px);
}
.point-value {
  font-size: rems(44px);
}
.text3 {
  text-align: center;
  margin-bottom: rems(6px);
}
</style>
